import React, { useState, useEffect } from "react";
import "./Malumot.css";
import rasm from "../Rasm/foydalanuvchi.png";
import { FaRegBell, FaCog, FaDoorOpen, FaDoorClosed, FaStar } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import CONFIG from "../config";

export default function Malumot({ userData, darajalar }) {
  const [isLogoutHovered, setIsLogoutHovered] = useState(false);

  // Default values if userData is missing or loading
  const {
    fio = "Foydalanuvchi",
    tanga_balansi = 0,
    rank = {}
  } = userData || {};

  const titles = darajalar && darajalar.length > 0 ? darajalar : [
    "Piyoda", "Suvoriy", "Leytinant", "Kapitan", "Mayor",
    "Sharafli", "Kanoner", "General", "Amir", "Rasuljon"
  ];

  // Calculate rank title from userData.daraja
  const darajaRaw = userData?.daraja;
  let title = "O'quvchi";

  if (darajaRaw) {
    if (typeof darajaRaw === 'number' || !isNaN(darajaRaw)) {
      const darajaLevel = parseInt(darajaRaw);
      // levels are 1-based (1=Piyoda, 2=Suvoriy)
      const index = darajaLevel - 1;
      if (index >= 0 && index < titles.length) {
        title = titles[index];
      } else if (index >= titles.length) {
        title = titles[titles.length - 1]; // Cap at last rank
      }
    } else {
      // If it's already a string, use it
      title = darajaRaw;
    }
  }

  return (
    <div className="foydalanuvchi-malumot">
      <div className="foydalanuvchi-rasm">
        <img src={rasm} alt="User" />
      </div>
      <div className="foydalanuvchi-ism">
        <div className="foydalanuvchi-daraja" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          {title}
        </div>
        <div className="foydalanuvchi-nomi">
          {fio}
        </div>
      </div>
    </div>
  );
}
